import { useState } from "react";
import { rankingTabs } from "@/mocks/homeData";

const trendIcon: Record<string, { icon: string; cls: string; label: string }> = {
  up: { icon: "ri-arrow-up-line", cls: "text-accent-600", label: "上升" },
  down: { icon: "ri-arrow-down-line", cls: "text-secondary-600", label: "下降" },
  same: { icon: "ri-subtract-line", cls: "text-foreground-400", label: "持平" },
};

export default function RankingSection() {
  const [activeKey, setActiveKey] = useState(rankingTabs[0].key);
  const activeTab = rankingTabs.find((t) => t.key === activeKey) ?? rankingTabs[0];

  return (
    <section id="ranking" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-5">
          <div className="max-w-2xl">
            <span className="text-xs md:text-sm font-label tracking-[0.2em] text-primary-600 uppercase">
              Rankings
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              热门榜单，看看大家在追什么
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              根据近期浏览与更新活跃度整理的三份榜单，每周滚动调整。
              点击标签可切换影视、小说与听书榜，快速找到当下最受关注的条目。
            </p>
          </div>

          <div className="inline-flex items-center gap-1 p-1 rounded-full bg-background-50 border border-background-200">
            {rankingTabs.map((t) => (
              <button
                key={t.key}
                type="button"
                onClick={() => setActiveKey(t.key)}
                className={`px-4 py-1.5 rounded-full text-xs md:text-sm whitespace-nowrap transition-colors cursor-pointer ${
                  activeKey === t.key
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-700 hover:text-primary-700"
                }`}
              >
                {t.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-1">
          {activeTab.items.map((item) => {
            const t = trendIcon[item.trend] ?? trendIcon.same;
            return (
              <div
                key={item.title}
                className="flex items-center gap-4 py-3.5 border-b border-background-200"
              >
                <span
                  className={`w-8 h-8 shrink-0 rounded-md font-heading font-bold flex items-center justify-center text-sm ${
                    item.rank <= 3
                      ? "bg-accent-500 text-background-50"
                      : "bg-background-200 text-foreground-700"
                  }`}
                >
                  {item.rank}
                </span>
                <div className="min-w-0 flex-1">
                  <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 truncate">
                    {item.title}
                  </h3>
                  <p className="text-[11px] text-foreground-500 truncate">{item.meta}</p>
                </div>
                <span
                  className={`flex items-center gap-1 text-xs whitespace-nowrap ${t.cls}`}
                  title={t.label}
                >
                  <i className={t.icon} aria-hidden="true"></i>
                  {t.label}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}